import React, { useEffect, useState } from "react";
import "../../../../App.css";
import SideMenu from "../../../../Components/SideDrawer";
import { Col, Row, Container, Form, Button, Table } from "react-bootstrap";
import PageHeader from "../../../../Components/Header";
import { companyGet, employeeGet, employeeAttendanceReport } from "../../../../Api/Admin/AdminApi"
import { extractErrorMessage } from "../../../../Utils/ErrorUtlis";
import { formatDate, formatTime } from "../../../../Utils/DateUtlis";


const EmployeeAttendance = () => {

  const [organizations, setOrganizations] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [apiData, setApiData] = useState([]);
  const [loadingCompany, setLoadingComapany] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const initialData = {
    company_id: null,
    emp_id: '',
    att_month: ''
  }
  const [formData, setFormData] = useState(initialData);

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const data = await companyGet();
        if (data) {
          const companies = data.map(i => ({
            id: i._id,
            name: i.name,
            description: i.description,
            status: i.status
          }));
          setOrganizations(companies);
          setLoadingComapany(true)
          console.log(`API Data ${JSON.stringify(organizations)}`);  // Under Production         
        } else {
          console.log('No Organization data to fetch');
          alert('No data to Fetch');
        }

      } catch (err) {
        const errorMessage = extractErrorMessage(err)
        console.log('Error Fetching Data in Organization: ', errorMessage || err);
        alert(errorMessage)
      }
    }
    fetchCompany();
  }, [])
  const onEmployeedetails = async (id) => {
    try {
      const employees = await employeeGet(id);
      console.log("Employee data from API", employees);

      if (employees && employees.result) {
        const emp = employees.result.map(i => ({
          emp_id: i.emp_id,
          emp_name: i.emp_name,
          team: i.team,
          team_id: i.team_id
        }));
        setEmployeeData(emp)
        // getTeam();
        // setIsLoading(false)
      } else {
        // setIsLoading(true)
      }

    } catch (err) {
      setIsLoading(false)
      const errorMessage = extractErrorMessage(err);
      console.log('Error Fetching Employee data', errorMessage || err);
      alert(errorMessage);
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (name === 'company_id') {
      onEmployeedetails(value)
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const responseData = await employeeAttendanceReport(formData);
      console.log('Attendance Data: ', responseData);

      if (responseData.results) {
        const employeeAttendance = responseData.results.map(i => ({
          _id: i._id,
          emp_id: i.emp_id,
          emp_name: i.emp_name,
          emp_attendance_date: formatDate(i.emp_attendance_date),
          emp_login_time: formatTime(i.emp_login_time),
          emp_logout_time: formatTime(i.emp_logout_time),
          emp_over_time: i.emp_over_time,
          working_meter: i.working_meter,
          Project: i.Project,
          Team: i.Team
        }));
        setApiData(employeeAttendance);
        setIsLoading(true)
        // setFormData(initialData)
      }
    } catch (err) {
      setIsLoading(false);
      setFormData(initialData)
      const errorMessage = extractErrorMessage(err)
      console.log('Error Fetching Attendance Data: ', errorMessage || err);
      alert(errorMessage)
    }
  }

  return (
    <div>
      <SideMenu />
      <Container fluid style={{
        marginLeft: '250px',
        padding: '20px',
        transition: 'margin 0.3s ease',
        width: 'calc(100% - 250px)'
      }}>
        <PageHeader title="Employee Attendance Report " showButtons={true} />
        <Form onSubmit={handleSubmit} className="mt-4 align-items-center">
          <Row className='mb-3'>
            <Form.Group as={Col} md="4" controlId="company_id">
              <Form.Label>Organization Name</Form.Label>
              <Form.Select
                name="company_id"
                value={formData.company_id}
                onChange={handleChange}
                required
              >
                <option value="">Select Organization</option>
                {!loadingCompany ? (<div>Loading...</div>) : (organizations.map(org => (
                  <option key={org.id} value={org.id}>{org.name}</option>
                )))}
              </Form.Select>
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="emp_id">
              <Form.Label>Employee Name</Form.Label>
              <Form.Select
                name="emp_id"
                value={formData.emp_id}
                onChange={handleChange}
                required
              >
                <option value="">Select Employee</option>
                {!loadingCompany ? (<div>Loading...</div>) : (employeeData.map(emp => (
                  <option key={emp.emp_id} value={emp.emp_id}>{emp.emp_name}</option>
                )))}
              </Form.Select>
            </Form.Group>
            <Form.Group as={Col} md='4' controlId="att_month">
              <Form.Label>Select Month</Form.Label>
              <Form.Control
                type="month"
                name="att_month"
                value={formData.att_month}
                onChange={handleChange}
                required
                style={{ height: '30px' }}
              >
              </Form.Control>
            </Form.Group>
          </Row>
          <Row className="mb-3 justify-content-center">
            <Form.Group as={Col} md='4' className="text-center">
              <Button type="submit" variant="primary" className="d-flex align-items-center mb-2" style={{ marginTop: '25px', height: '30px' }}>
                View
              </Button>
            </Form.Group>
          </Row>
        </Form>

        {!isLoading ? <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
          <div role="status">
            <span className="sr-only">No Data to Show</span>
          </div>
        </div> : <div tyle={{ overflow: 'auto' }}>
          <Table striped hover responsive='sm' size="sm">
            <thead>
              <tr>
                <th className="fs-12">Emp Id</th>
                <th className="fs-12">Name</th>
                <th className="fs-12">Attendance Date</th>
                <th className="fs-12">Login Time</th>
                <th className="fs-12">Logout Time</th>
                <th className="fs-12">Overtime</th>
              </tr>
            </thead>
            <tbody>
              {apiData.map((emp, i) => (
                <tr key={emp.emp_id}>
                  <td className="fs-12">
                    {emp.emp_id}
                  </td>
                  <td className="fs-12">
                    {emp.emp_name}
                  </td>
                  <td className="fs-12">
                    {emp.emp_attendance_date}
                  </td>
                  <td className="fs-12">
                    {emp.emp_login_time}
                  </td>
                  <td className="fs-12">
                    {emp.emp_logout_time}
                  </td>
                  <td className="fs-12">
                    {emp.emp_over_time}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        }
      </Container>
    </div>
  )
};

export default EmployeeAttendance;